<template>
  <div id="main-content">
    <PanelCard :home-show-data="spendShowData" style="display: flex;flex-wrap: wrap;"></PanelCard>
    <a-card
            style="width: 100%;flex: 1;overflow-y: hidden;border-radius: 5px"
            :bodyStyle="{padding:'0',overflowY:'scroll',height: 'calc(100% - 65px)'}" >
      <div slot="title">
        渠道收益汇总
        <a-tooltip style="cursor: pointer">
          <template slot="title" >
            <div v-for="item_channel in Object.keys($store.state.RevenueChange)">
              渠道：{{item_channel}} <br>
              处理：{{$store.state.RevenueChange[item_channel]}}
            </div>
          </template>
          <a-icon type="info-circle" theme="filled" />
        </a-tooltip>
      </div>
      <div slot="extra">
        <!--<a-select v-model="product" style="width: 240px" allowClear showSearch-->
        <!--          :maxTagCount="1" placeholder="请选择产品"-->
        <!--          optionFilterProp="label"-->
        <!--          @change="changeDate()">-->
        <!--  <a-select-option v-for="productItem in $store.getters.getAppAll"-->
        <!--                   :label="productItem.app_name"-->
        <!--                   :value="productItem.app_id"-->
        <!--                   :key="productItem.app_id">-->
        <!--    <img :src="productItem.icon" style="height: 28px;border-radius: 5px;">-->
        <!--    {{productItem.app_name}}-->
        <!--  </a-select-option>-->
        <!--</a-select>-->
        <a-button type="danger" ghost @click="()=>{changeRatioShow = true}">系数修正</a-button>
        <a-select v-model="channel" style="width: 200px" allowClear
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择展示渠道"
                  @change="changeChannel">
          <a-select-option v-for="channelItem in $store.state.RevenueChannel"
                           :label="channelItem.name"
                           :value="channelItem.value"
                           :key="channelItem.value">
            {{channelItem.name}}
          </a-select-option>
        </a-select>
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="changeDate()" />
        <a-button type="primary">导出</a-button>
      </div>
      <a-table :columns="getTableColumns" id="show-table"
               style="height:100%;overflow-y: hidden;background: #ffffff"
               :scroll="{ x:'500px', y: _get_table_scroll({id:'show-table'}) }"
               :rowKey="item=>item.date" :loading="tableLoad"
               :data-source="tableData" bordered :pagination="false">
        <template :slot="channel_item.value" slot-scope="text,recode" v-for="channel_item in $store.state.RevenueChannel">
          <div v-if="recode.date!=='汇总'">{{ text }}</div>
          <a v-else @click="changeData(text,channel_item.value)">{{text}}</a>
        </template>
<!--        <template slot="footer">-->
<!--          <a-alert-->
<!--            description="一周内渠道维度汇总数据，相关联渠道对接人员按周核对数据，提交数据误差"-->
<!--            type="info"-->
<!--            show-icon-->
<!--          />-->
<!--        </template>-->
      </a-table>
    </a-card>
    <RatioDialog
      :show-dialog="changeRatioShow" :is-ios="0"
      @close-dialog="()=>{changeRatioShow=false}"></RatioDialog>
    <DataErrorDialog
      :show-dialog="changeDataShow"
      :base-info="changeDataInfo"
      @close-dialog="()=>{changeDataShow=false}"></DataErrorDialog>
  </div>
</template>

<script>
import PanelCard from "../../components/V1/PanelCard";
import {GetCashChannelSummary, GetCashSummary} from "../../api/v1/cash_api";
import DataErrorDialog from "../../components/Business/Dialog/DataErrorDialog";
import RatioDialog from "../../components/Business/Dialog/RatioDialog";
export default {
  name: "Index",
  components: {RatioDialog, DataErrorDialog, PanelCard},
  data() {
    return {
      date:['',''],
      channel:[],
      product:'',
      spendShowData:[],
      tableData:[],
      tableLoad:false,
      changeDataInfo:{},
      changeDataShow:false,
      changeRatioShow:false
    }
  },
  mounted() {
    this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [{
        title: '日期',
        dataIndex: 'date',
        fixed:'left',
        width:200,
        scopedSlots: { customRender: 'date' },
        align:'center'
      }]
      this.$store.state.RevenueChannel.forEach(item => {
        if (this.channel.length===0||this.channel.includes(item.value)){
          _table_columns.push({
            title: item.name,
            width:180,
            dataIndex: item.value,
            align:'center',
            scopedSlots: { customRender: item.value },
          })
        }
      })
      _table_columns.push({
        title: '汇总',
        dataIndex: 'count',
        fixed:'right',
        width:200,
        scopedSlots: { customRender: 'count' },
        align:'center'
      })
      return _table_columns
    }
  },
  methods :{
    init_data(){
      GetCashSummary({}).then(resp => {
        if (resp.code===200){
          resp.data.forEach(item => {
            this.spendShowData.push(
              {
                // name:'Facebook',
                img:"<img src='/static/img/"+item.channel+".png' alt='"+item.channel+"' style='height: 20px;'/>",
                data:item.revenue,
                suffix:'$',
                arrow:item.arrow?'up':'down'
              }
            )
          })
          this.init_table_data()
        }
      })
    },
    init_table_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetCashChannelSummary({start:this.date[0],end:this.date[1],app_id:this.product}).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.date = resp.data.date
          this.tableData = resp.data.list
        }
      })
    },
    changeDate(){
      this.init_table_data()
    },
    changeChannel(){},
    changeData(num,channel){
      this.changeDataInfo = {
        now_num:num,
        channel:channel,
        type:'revenue',
        start:this.date[0],
        end:this.date[1],
        change_num:0
      }
      this.changeDataShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Revenue/Index.vue